export default __webpack_public_path__ + "static/media/businessplan.b74527a3.pdf";